export default function DashboardFooter() {
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 bg-hub-footer border-t border-hub-border h-9 flex items-center justify-center px-5">
      <span className="text-hub-muted text-[11px] tracking-wide">
        &copy; AC-2002169 DT CENTRE
      </span>
    </footer>
  );
}